import { lazy } from "react";

export const lazyWithMinDelay = (importFn, minMs = 0) =>
    lazy(() => {
        // console.log('[lazyWithMinDelay] Import started');
        // console.log('[lazyWithMinDelay] Minimum delay:', minMs, 'ms');

        const startTime = Date.now();

        return Promise.all([
            importFn().then((moduleExports) => {
                // console.log(
                //     '[lazyWithMinDelay] Module loaded in',
                //     Date.now() - startTime,
                //     'ms'
                // );
                return moduleExports;
            }),

            new Promise((resolve) =>
                setTimeout(() => {
                    // console.log(
                    //     '[lazyWithMinDelay] Minimum delay completed after',
                    //     minMs,
                    //     'ms'
                    // );
                    resolve();
                }, minMs)
            ),
        ]).then(([moduleExports]) => {
            // console.log(
            //     '[lazyWithMinDelay] Ready after',
            //     Date.now() - startTime,
            //     'ms'
            // );

            return moduleExports;
        });
    });

export default lazyWithMinDelay;

